module.exports = {
    trolley: {
        productsUnavailableAtDeliveryLocation:
            'These products are not available from your new delivery location.',
        productsUnavailableAtPickupLocation:
            'These products are not available from your new pick up location.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/trolley.js